import React from 'react';
import { useAssetPreviewStore } from '../../store/assetPreviewStore';
import { useProjectPanelStore } from '../../store/projectPanelStore';
import { getAssetIcon, formatFileSize } from '../../../core/types/asset.types';
import { FileQuestion } from 'lucide-react';

interface NoPreviewProps {
  instanceId: string;
}

export const NoPreview: React.FC<NoPreviewProps> = ({ instanceId }) => {
  const { previews } = useAssetPreviewStore();
  const { assets } = useProjectPanelStore();

  const instance = previews[instanceId];
  const asset = instance ? assets[instance.assetId] : null;

  if (!instance || !asset) {
    return (
      <div className="flex-1 flex items-center justify-center text-zinc-500">
        Asset not found
      </div>
    );
  }

  const icon = getAssetIcon(asset.type);

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
      {/* Large icon */}
      <div className="text-6xl mb-4 opacity-50">{icon}</div>

      {/* Message */}
      <div className="flex items-center gap-2 text-zinc-400 mb-2">
        <FileQuestion size={18} />
        <span className="text-sm">Preview not available</span>
      </div>

      {/* File info */}
      <div className="text-zinc-500 text-xs space-y-1">
        <div className="font-medium text-zinc-300">{asset.name}</div>
        <div>Type: {asset.type}</div>
        <div>Size: {formatFileSize(asset.metadata?.fileSize || 0)}</div>
        <div className="text-zinc-600 break-all">{asset.path}</div>
      </div>

      {/* Hint */}
      <div className="mt-6 text-xs text-zinc-600 max-w-xs">
        This file type does not support preview. You can view it using an external application.
      </div>
    </div>
  );
};
